const addInfo = {
  title: 'Trailer',
  icon: 'trailer'
}
const trailerRouter = {
  path: '/trailer',
  meta: {
    title: 'Trailer',
    icon: 'trailer',
    permission: ['trailer_management']
  },
  children: [
    {
      path: 'manage-trailer',
      component: () => import('@/views/trailer/ManageTrailer/manage-trailer'),
      name: 'ManageTrailer',
      meta: { title: 'Trailer', parent: addInfo, permission: ['trailer_enable'] }
    },
    // {
    //   path: 'manage-trailer-form/:id?',
    //   component: () => import('@/views/trailer/ManageTrailer/manage-trailer-form'),
    //   name: 'ManageTrailerForm',
    //   hidden: true,
    //   meta: { title: 'ManageTrailerForm', parent: addInfo, activeMenu: '/trailer/manage-trailer', enableBack: true, backPage: 'ManageTrailer'  }
    // },
    {
      path: 'create-trailer-form',
      component: () => import('@/views/trailer/ManageTrailer/manage-trailer-form'),
      name: 'ManageTrailerForm',
      hidden: true,
      meta: { 
          title: 'ManageTrailerForm', 
          activeMenu: '/trailer/manage-trailer',         
          enableBack: true,
          backPage: 'ManageTrailer',
          parent: addInfo,
          // parentIcon: 'vehicle',
          permission: ['trailer_create']
      }
    },
    {
      path: 'update-trailer-form/:id?',
      component: () => import('@/views/trailer/ManageTrailer/manage-trailer-form'),
      name: 'UpdateTrailerForm',
      hidden: true,
      meta: { 
          title: 'ManageTrailerForm', 
          activeMenu: '/trailer/manage-trailer',         
          enableBack: true,
          backPage: 'ManageTrailer',
          parent: addInfo,
          // parentIcon: 'vehicle',
          permission: ['trailer_update']
      }
    },
    // {
    //   path: 'trailer-tracking-page',
    //   component: () => import('@/views/trailer/TrailerTrackingPage/trailer-tracking-page'),
    //   name: 'TrailerTrackingPage',
    //   meta: { title: 'TrailerTrackingPage', parent: addInfo }
    // },
    // {
    //   path: 'trailer-profile/:id',
    //   component: () => import('@/views/trailer/TrailerTrackingPage/trailer-profile'),
    //   name: 'TrailerProfile',
    //   hidden: true,
    //   meta: { title: 'TrailerProfile', parent: addInfo, activeMenu: '/trailer/trailer-tracking-page' }
    // },
  ]
}

export default trailerRouter
